import { render, staticRenderFns } from "./edit-cognitive-test-fluid.vue?vue&type=template&id=5ee5a89e&"
import script from "./edit-cognitive-test-fluid.vue?vue&type=script&lang=js&"
export * from "./edit-cognitive-test-fluid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports